class AccordionImages extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('accordion-tab'));
    this.cards = Array.from(this.querySelectorAll('.accordion-images__card'));

    this.tabs.forEach((tab) => {
      const details = tab.querySelector('details');
      if (!details) return;

      details.addEventListener('toggle', () => {
        if (details.open) {
          this.setActiveCard(tab.dataset.blockId);
          this.closeOthers(tab);
        }
        this.syncPlayback();
      });
    });

    window.matchMedia('(min-width: 750px)').addEventListener('change', () => this.syncPlayback());
    this.syncPlayback();

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const tab = event.target;
        if (!this.contains(tab)) return;

        this.setActiveCard(tab.dataset.blockId);

        const details = tab.querySelector('details');
        if (details && !details.open) {
          tab.querySelector('summary').click();
        }
      });
    }
  }

  closeOthers(current) {
    this.tabs.forEach((tab) => {
      if (tab === current) return;

      const details = tab.querySelector('details');
      if (!details || !details.open || tab.isClosing) return;

      if (typeof tab.shrink === 'function') {
        details.style.overflow = 'hidden';
        tab.shrink();
      }
      else {
        details.open = false;
      }
    });
  }

  setActiveCard(blockId) {
    this.cards.forEach((card) => {
      card.classList.toggle('is-active', card.dataset.blockId === blockId);
    });
    this.syncPlayback();
  }

  syncPlayback() {
    this.querySelectorAll('video').forEach((video) => {
      if (video.closest('[data-video-hero]') && this.isVisible(video)) {
        if (video.paused) video.play().catch(() => {});
      }
      else if (!video.paused) {
        video.pause();
      }
    });

    this.querySelectorAll('video-section iframe').forEach((frame) => {
      if (this.isVisible(frame)) return;

      const type = frame.closest('video-section').dataset.type;
      if (type === 'youtube') {
        frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
      else if (type === 'vimeo') {
        frame.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    });
  }

  isVisible(element) {
    const card = element.closest('.accordion-images__card');
    if (card && !card.classList.contains('is-active')) return false;

    const details = element.closest('details');
    if (details && !details.open) return false;

    return element.offsetParent !== null;
  }
}
customElements.define('accordion-images', AccordionImages);
